module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.e0d5280b.eot";